import { useEffect, useRef } from 'react';
import { shallow } from 'zustand/shallow';

import {
  selectConfigByInstance,
  useDataBuilderSelector,
} from './data-builder.store';

type CompanySelectionGateUnitOfAnalysisSyncProps = {
  resetRequest: (instanceId: string) => void;
};

function selectUnitOfAnalysisByInstance(
  configByInstance: ReturnType<typeof selectConfigByInstance>
): Record<string, string | null> {
  return Object.fromEntries(
    Object.entries(configByInstance).map(([instanceId, config]) => [
      instanceId,
      config.unitOfAnalysis,
    ])
  );
}

export const CompanySelectionGateUnitOfAnalysisSync = ({
  resetRequest,
}: CompanySelectionGateUnitOfAnalysisSyncProps) => {
  const unitOfAnalysisByInstance = useDataBuilderSelector(
    (state) => selectUnitOfAnalysisByInstance(selectConfigByInstance(state)),
    shallow
  );
  const previousValuesRef = useRef<Record<string, string | null>>({});

  useEffect(() => {
    const previousValues = previousValuesRef.current;

    for (const [instanceId, nextUnitOfAnalysis] of Object.entries(
      unitOfAnalysisByInstance
    )) {
      const previousUnitOfAnalysis = previousValues[instanceId];
      const hasPreviousValue =
        previousUnitOfAnalysis !== undefined || instanceId in previousValues;

      if (!hasPreviousValue) {
        continue;
      }

      if (
        previousUnitOfAnalysis !== null &&
        previousUnitOfAnalysis !== nextUnitOfAnalysis
      ) {
        resetRequest(instanceId);
      }
    }

    for (const instanceId of Object.keys(previousValues)) {
      if (instanceId in unitOfAnalysisByInstance) {
        continue;
      }
      resetRequest(instanceId);
    }

    previousValuesRef.current = unitOfAnalysisByInstance;
  }, [resetRequest, unitOfAnalysisByInstance]);

  return null;
};
